export default __webpack_public_path__ + "static/media/txt2_pc@2x.84ed428e.png";